import { string, z } from 'zod'
import { rentabilitySchema } from '@/modules/settings/tasa/types/types.ts'

export const promotionSchema = z.object({
  id: z.number(),
  name: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  initialPercentage: z.string(),
  noCreditLimits: z.boolean(),
  insuranceRentabilityId: z.coerce.string().nullish(),
  // The back sends the promotion's Weppa Plus as an object
  insuranceRentability: z
    .object({ id: z.coerce.string(), name: z.string().nullish() })
    .nullish(),
  insurancePercent: z.coerce.string().nullish(),
  minCost: z.coerce.string().nullish(),
  maxCost: z.coerce.string().nullish(),
  rentability: rentabilitySchema.omit({ id: true }).merge(
    z.object({
      rentabilityId: string()
    })
  )
})
